import { isAnyOf, Middleware } from "@reduxjs/toolkit";
import { State } from "../state/types";
import { getSteps } from "components/Signup/steps";
import { resetAction } from "..";
import { stateStore } from "components/Signup/flow/utils/stateStore";
import { resumePreviewStore } from "components/Signup/flow/utils/previewStore";
import { updateRoute } from "./utils/updateRoute";

const steps = getSteps();

export const resetMiddleware: Middleware<{}, State> =
  (storeApi) => (next) => async (action) => {
    const result = next(action);

    if (isAnyOf(resetAction)(action)) {
      stateStore.remove();
      resumePreviewStore.remove();
      updateRoute({
        route: steps[0].name,
        state: storeApi.getState(),
        replace: true,
      });

      return result;
    }

    return result;
  };
